import { useDialog } from "@hooks";
import { FormValues } from "./components/service-preference-form-modal";
import {
  useCreateConsultantServicePreferenceMutation,
  useUpdateConsultantServicePreferenceMutation,
  useChangeConsultantServicePreferenceStatusMutation,
  useGetConsultantServicePreferencesQuery,
  useDeleteConsultantServicePreferenceMutation,
  GetConsultantServicePreferences,
  useGetConsultantServicePreferenceFormLazyQuery,
  GetConsultantServicePreferencesForBooking
} from "@bonliva-crm/graphql";

export const useServicePreferencesStore = () => {
  const formDialog = useDialog<{ values?: FormValues; servicePrefId?: string }>();

  function useServicePrefs(consultantId: string) {
    return useGetConsultantServicePreferencesQuery({
      fetchPolicy: "network-only",
      variables: { consultantId }
    });
  }

  const [getServicePrefForm, servicePrefFormState] =
    useGetConsultantServicePreferenceFormLazyQuery({
      fetchPolicy: "network-only"
    });

  const refetchQueries = [
    GetConsultantServicePreferences.OperationName,
    GetConsultantServicePreferencesForBooking.OperationName
  ];

  const [createServicePref] = useCreateConsultantServicePreferenceMutation({
    fetchPolicy: "network-only",
    refetchQueries
  });

  const [deleteServicePref] = useDeleteConsultantServicePreferenceMutation({
    fetchPolicy: "network-only",
    refetchQueries
  });

  const [updateServicePref] = useUpdateConsultantServicePreferenceMutation({
    fetchPolicy: "network-only",
    refetchQueries
  });

  const [changeServicePrefStatus] = useChangeConsultantServicePreferenceStatusMutation({
    fetchPolicy: "network-only",
    refetchQueries
  });

  return {
    formDialog,
    createServicePref,
    updateServicePref,
    deleteServicePref,
    changeServicePrefStatus,
    getServicePrefForm,
    useServicePrefs,
    servicePreferenceForm: {
      get: getServicePrefForm,
      loading: servicePrefFormState.loading,
      data: servicePrefFormState.data?.consultantServicePreferenceForm
    }
  };
};
